import VueRouter from 'vue-router'
import { setPageTitle } from '@/helpers/pageTitle'

// Layout
const BaseLayout = () => import('@/views/_layouts/BaseLayout')

// Common Pages
const Comingsoon = () => import('@/views/_general/Comingsoon')
const Error404 = () => import('@/views/_general/404')
const ForgotPassword = () => import('@/views/_general/ForgotPassword')
const VerifyEmail = () => import('@/views/_general/VerifyEmail')
const Login = () => import('@/views/_general/Login')
const Register = () => import('@/views/_general/Register')
const ResetPassword = () => import('@/views/_general/ResetPassword')

// Pages
const AuthProfile = () => import('@/views/_auth/AuthProfile')

const Home = () => import('@/views/_general/Home')

const CustomerList = () => import('@/views/Customers/CustomerList')
const AdminList = () => import('@/views/Admins/AdminList')
const CustomerProfile = () => import('@/views/Customers/CustomerProfile')

const VendorList = () => import('@/views/Vendors/VendorList')
const VendorProfile = () => import('@/views/Vendors/VendorProfile')

const CategoryList = () => import('@/views/Categories/CategoryList')
const CategoryProfile = () => import('@/views/Categories/CategoryProfile')

const CategoryTagList = () => import('@/views/CategoryTags/CategoryTagList')
const CategoryTagProfile = () => import('@/views/CategoryTags/CategoryTagProfile')

const BrandList = () => import('@/views/Brands/BrandList')
const ProductLabelList = () => import('@/views/ProductLabels/ProductLabelList')
const ProductFunctionList = () => import('@/views/ProductFunctions/ProductFunctionList')

const OurCustomerList = () => import('@/views/OurCustomers/OurCustomerList')

const ProductList = () => import('@/views/Products/ProductList')
const ProductProfile = () => import('@/views/Products/ProductProfile')
const ProductImport = () => import('@/views/Products/ProductImport')
const ProductBulkUpdate = () => import('@/views/Products/ProductBulkUpdate')
const ShippingQuoteReport = () => import('@/views/Products/ShippingQuoteReport')
const ProductImageUpload = () => import('@/views/Products/ProductImageUpload')

const PackageList = () => import('@/views/Packages/PackageList')
const PackageProfile = () => import('@/views/Packages/PackageProfile')
const PackageImport = () => import('@/views/Packages/PackageImport')
const PackageBulkUpdate = () => import('@/views/Packages/PackageBulkUpdate')

const QuotationList = () => import('@/views/Quotations/QuotationList')
const QuotationProfile = () => import('@/views/Quotations/QuotationProfile')

const CouponList = () => import('@/views/Coupons/CouponList')
const CouponProfile = () => import('@/views/Coupons/CouponProfile')

const SupportiveSingle = () => import('@/views/Supports/SupportiveSingle')

const FAQList = () => import('@/views/Supports/FAQ')

const AuditTrailList = () => import('@/views/AuditTrails/AuditTrailList')
const AuditTrailProfile = () => import('@/views/AuditTrails/AuditTrailProfile')

const EmailBlastList = () => import('@/views/EmailBlast/EmailBlastList')

const AnnouncementList = () => import('@/views/Announcements/AnnouncementList')

const AdvertisementList = () => import('@/views/Advertisements/AdvertisementList')

const SystemVariableList = () => import('@/views/SystemVariables/SystemVariableList')

const BroadcastList = () => import('@/views/Broadcasts/BroadcastList')

const BannerList = () => import('@/views/Banners/BannerList')

const AnnouncementBarList = () => import('@/views/AnnouncementBars/AnnouncementBarList')

const SolutionForm = () => import('@/views/Solutions/SolutionForm')

const CurrencyList = () => import('@/views/SystemCurrency/CurrencyList')

const CommitmentForm = () => import('@/views/Commitments/CommitmentForm')

const WhoWeAreForm = () => import('@/views/WhoWeAre/WhoWeAreForm')

const OverviewList = () => import('@/views/Overview/OverviewList')

const LaboratoryList = () => import('@/views/Laboratory/LaboratoryList')

const LaboratoryOperationList = () => import('@/views/LaboratoryOperation/LaboratoryOperationList')

const WhyOneScienceList = () => import('@/views/WhyOneScience/WhyOneScienceList')

const TaxList = () => import('@/views/Tax/TaxList')
const CompanyList = () => import('@/views/Companies/CompanyList')

const SgShippingList = () => import('@/views/ShippingRates/SgShipping/SgShippingList')

const ThirdPartyShippingList = () => import('@/views/ShippingRates/ThirdPartyShipping/ThirdPartyShippingList')

const ShippingSimulator = () => import('@/views/ShippingRates/ShippingSimulator')

// Routes
// ** for more information, kindy refer to https://github.com/websanova/vue-auth/blob/master/docs/Privileges.md
// ** auth: true <- can be access only if auth.check = true
// ** auth: false <- cannot be access is auth.check = true
// ** auth: null, title: '' <- no auth rule
// ** auth: ["admin",2] <- can be access is auth.user.role matched

const baseLayoutRoutes = [
	{ path: '/comingsoon', name: 'admin.home2', component: Comingsoon, meta: { auth: true, role: ["admin"], title: 'Coming Soon' } },
	{ path: '/home', name: 'home', component: Home, meta: { auth: true, role: ["admin"], title: 'Home' } },

	{ path: '/my/profile', name: 'my.profile', component: AuthProfile, meta: { auth: true, role: ["admin"], title: 'Profile' } },
	{ path: '/user/profile', name: 'user.my-profile', component: CustomerProfile, meta: { auth: true, role: ["admin"], title: 'My Profile' } },

	// admin accounts
	{ path: '/admin-user/list', name: 'admin-user.list', component: AdminList, meta: { auth: true, role: ["admin"], title: 'Admin List' } },

	// customer
	{ path: '/customer/list', name: 'customer.list', component: CustomerList, meta: { auth: true, role: ["admin"], title: 'Customer List' } },
	{ path: '/customer/profile/:id', name: 'customer.profile', component: CustomerProfile, meta: { auth: true, role: ["admin"], title: 'Customer Profile' } },
	{ path: '/customer/profile', name: 'customer.my-profile', component: CustomerProfile, meta: { auth: true, role: ["admin"], title: 'My Profile' } }, //delete?
	
	// vendor
	{ path: '/vendor/list', name: 'vendor.list', component: VendorList, meta: { auth: true, role: ["admin"], title: 'Vendor List' } },
	{ path: '/vendor/profile/:id', name: 'vendor.profile', component: VendorProfile, meta: { auth: true, role: ["admin"], title: 'Vendor Profile' } },
	
	// category
	{ path: '/category/list', name: 'category.list', component: CategoryList, meta: { auth: true, role: ["admin"], title: 'Category List' } },
	{ path: '/category/profile/:id', name: 'category.profile', component: CategoryProfile, meta: { auth: true, role: ["admin"], title: 'Category Profile' } },

	// category tag
	{ path: '/category-tag/list', name: 'category_tag.list', component: CategoryTagList, meta: { auth: true, role: ["admin"], title: 'Category Tag List' } },
	{ path: '/category-tag/profile/:id', name: 'category_tag.profile', component: CategoryTagProfile, meta: { auth: true, role: ["admin"], title: 'Category Tag Profile' } },
	
	// brand
	{ path: '/brand/list', name: 'brand.list', component: BrandList, meta: { auth: true, role: ["admin"], title: 'Brand List' } },
	{ path: '/product-label/list', name: 'product-label.list', component: ProductLabelList, meta: { auth: true, role: ["admin"], title: 'Application Labels' } },
	{ path: '/product-function/list', name: 'product-function.list', component: ProductFunctionList, meta: { auth: true, role: ["admin"], title: 'Function Labels' } },

	// our customer
	{ path: '/our-customer/list', name: 'our_customer.list', component: OurCustomerList, meta: { auth: true, role: ["admin"], title: 'Our Customer List' } },

	// product
	{ path: '/product/list', name: 'product.list', component: ProductList, meta: { auth: true, role: ["admin"], title: 'Product List' } },
	{ path: '/product/profile/:id', name: 'product.profile', component: ProductProfile, meta: { auth: true, role: ["admin"], title: 'Product Profile' } },
	{ path: '/product/import', name: 'product.import', component: ProductImport, meta: { auth: true, role: ["admin"], title: 'Product Import' } },
	{ path: '/product/bulk-update', name: 'product.bulk-update', component: ProductBulkUpdate, meta: { auth: true, role: ["admin"], title: 'Product Bulk Update' } },
	{ path: '/product/image-upload', name: 'product.image-upload', component: ProductImageUpload, meta: { auth: true, role: ["admin"], title: 'Mass Image Upload' } },
	{ path: '/product/shipping-quote-report', name: 'product.shipping-quote-report', component: ShippingQuoteReport, meta: { auth: true, role: ["admin"], title: "Products That Can't Get a Shipping Quote" } },

	// package
	{ path: '/package/list', name: 'package.list', component: PackageList, meta: { auth: true, role: ["admin"], title: 'Package List' } },
	{ path: '/package/profile/:id', name: 'package.profile', component: PackageProfile, meta: { auth: true, role: ["admin"], title: 'Package Profile' } },
	{ path: '/package/import', name: 'package.import', component: PackageImport, meta: { auth: true, role: ["admin"], title: 'Package Import' } },
	{ path: '/package/bulk-update', name: 'package.bulk-update', component: PackageBulkUpdate, meta: { auth: true, role: ["admin"], title: 'Package Bulk Update' } },

	// quotation
	{ path: '/quotation/list', name: 'quotation.list', component: QuotationList, meta: { auth: true, role: ["admin"], title: 'Quotation List' } },
	{ path: '/quotation/profile/:id', name: 'quotation.profile', component: QuotationProfile, meta: { auth: true, role: ["admin"], title: 'Quotation Profile' } },

	// coupon => voucher
	{ path: '/voucher/list', name: 'voucher.list', component: CouponList, meta: { auth: true, role: ["admin"], title: 'Voucher List' } },
	{ path: '/voucher/profile/:id', name: 'voucher.profile', component: CouponProfile, meta: { auth: true, role: ["admin"], title: 'Voucher Profile' } },
	
	// support
	{ path: '/support/about-us', name: 'support.about-us', component: SupportiveSingle, meta: { auth: true, role: ["admin"], title: 'About Us', params: { type: 'about-us' } } },
	{ path: '/support/user-agreement', name: 'support.user-agreement', component: SupportiveSingle, meta: { auth: true, role: ["admin"], title: 'User Agreement', params: { type: 'user-agreement' } } },
	{ path: '/support/privacy-policy', name: 'support.privacy-policy', component: SupportiveSingle, meta: { auth: true, role: ["admin"], title: 'Privacy Policy', params: { type: 'privacy-policy' } } },


	//audit trails
	{ path: '/audit-trail/list', name: 'audit-trail.list', component: AuditTrailList, meta: { auth: true, role: ["admin"], title: 'Audit Trail List' } },
	{ path: '/audit-trail/profile/:id', name: 'audit-trail.profile', component: AuditTrailProfile, meta: { auth: true, role: ["admin"], title: 'Audit Trail Profile' } },

	//email blast
	{ path: '/email-blast/list', name: 'email-blast.list', component: EmailBlastList, meta: { auth: true, role: ["admin"], title: 'Email Blast' } },

	{ path: '/announcement/list', name: 'announcement.list', component: AnnouncementList, meta: { auth: true, role: ["admin"], title: 'Announcement List' } },

	{ path: '/advertisement/list', name: 'advertisement.list', component: AdvertisementList, meta: { auth: true, role: ["admin"], title: 'Advertisement List' } },

	{ path: '/settings/list', name: 'system-variable.list', component: SystemVariableList, meta: { auth: true, role: ["admin"], title: 'System Variable List' } },

	// broadcast
	{ path: '/broadcast/list', name: 'broadcast.list', component: BroadcastList, meta: { auth: true, role: ["admin"], title: 'Broadcast list' } },
	
	// banner
	{ path: '/banner_management/list', name: 'banner_management.list', component: BannerList, meta: { auth: true, role: ["admin"], title: 'Banner Management' } },

	// announcement bar
	{ path: '/announcement-bar/list', name: 'announcement_bar.list', component: AnnouncementBarList, meta: { auth: true, role: ["admin"], title: 'Announcement Bar' } },

	// solution
	{ path: '/solution/form', name: 'solution.form', component: SolutionForm, meta: { auth: true, role: ["admin"], title: 'Solution Form' } },
	
	// commitment
	{ path: '/commitment/form', name: 'commitment.form', component: CommitmentForm, meta: { auth: true, role: ["admin"], title: 'Commitment Form' } },
	
	// who we are
	{ path: '/who_we_are/form', name: 'who_we_are.form', component: WhoWeAreForm, meta: { auth: true, role: ["admin"], title: 'Who We Are Form' } },
	// { path: '/solution/list', name: 'solution.list', component: SolutionList, meta: { auth: true, role: ["admin"], title: 'Solution list' } },

	// currency
	{ path: '/currency/list', name: 'currency.list', component: CurrencyList, meta: { auth: true, role: ["admin"], title: 'Currency List' } },

	// overview
	{ path: '/overview/list', name: 'overview.list', component: OverviewList, meta: { auth: true, role: ["admin"], title: 'Overview List' } },
	
	// why one science
	{ path: '/why_one_science/list', name: 'why_one_science.list', component: WhyOneScienceList, meta: { auth: true, role: ["admin"], title: 'Why One Science? List' } },
	
	// laboratory services
	{ path: '/laboratory_services/list', name: 'laboratory_services.list', component: LaboratoryList, meta: { auth: true, role: ["admin"], title: 'Laboratory Services List' } },

	// laboratory operations
	{ path: '/laboratory_operations/list', name: 'laboratory_operations.list', component: LaboratoryOperationList, meta: { auth: true, role: ["admin"], title: 'Laboratory Operations List' } },
	
	// company (FEAT-01)
	{ path: '/company/list', name: 'company.list', component: CompanyList, meta: { auth: true, role: ["admin"], title: 'Companies' } },
	// tax
	{ path: '/tax/list', name: 'tax.list', component: TaxList, meta: { auth: true, role: ["admin"], title: 'Tax & Duty Rates' } },

	// shipping rates
	{ path: '/shipping-rate/sg-shipping', name: 'shipping_rate.sg_shipping', component: SgShippingList, meta: { auth: true, role: ["admin"], title: 'SG Shipping Management' } },
	{ path: '/shipping-rate/third-party-shipping', name: 'shipping_rate.third_party_shipping', component: ThirdPartyShippingList, meta: { auth: true, role: ["admin"], title: 'Third-Party Shipping Management' } },
	{ path: '/shipping-rate/simulator', name: 'shipping_rate.simulator', component: ShippingSimulator, meta: { auth: true, role: ["admin"], title: 'Shipping Simulator' } },
]

const routes = [

	{ path: '/', name: 'login', component: Login, meta: { auth: null, title: 'Login' } },
	{ path: '/login', name: 'login2', component: Login, meta: { auth: null, title: 'Login' } },
	{ path: '/register/:code', name: 'register', component: Register, meta: { auth: null, title: 'Register' } },
	{ path: '/password/reset/:token', name: 'reset.password', component: ResetPassword, meta: { auth: null, title: 'Reset Password' } },
	{ path: '/forgot-password', name: 'forgot.password', component: ForgotPassword, meta: { auth: null, title: 'Forgot Password' } },
	{ path: '/email-verify/:token', name: 'verify.email', component: VerifyEmail, meta: { auth: null, title: 'Verify Email' } },

	// base_layout
	{ path: '/home', name: 'base_layout', component: BaseLayout, children: baseLayoutRoutes },

	{ path: '*', name: '404', component: Error404, meta: { auth: null, title: '404' } },
]

const router = new VueRouter({
	history: true,
	mode: 'history',
	routes,
})

router.beforeEach((to, from, next) => {
	setPageTitle(to.meta.title)
	next()
});

export default router